export function statusOf(tag) {
  if (tag.type !== "analog") return "normal";
  const v = tag.value;
  if (tag.hihi != null && v >= tag.hihi) return "critical";
  if (tag.lolo != null && v <= tag.lolo) return "critical";
  if (tag.hi != null && v >= tag.hi) return "warning";
  if (tag.lo != null && v <= tag.lo) return "warning";
  return "normal";
}

export const statusColor = {
  critical: "#FF3B30",
  warning: "#FFCC00",
  normal: "#34C759",
  inactive: "#52525B",
};

export const statusText = {
  critical: "text-status-critical",
  warning: "text-status-warning",
  normal: "text-status-normal",
};
